import home from "./Home";
import gettingStarted from "./GettingStarted";
import header from "./Header";
export const homeData = home;
export const gettingStartedData = gettingStarted;
export const headerData = header;
